// extracted by mini-css-extract-plugin
export default {"menuOpened":"style_menuOpened__8wTXo","menuClosed":"style_menuClosed__EJrvJ"};